export const MultiUsersIcon = ({ size = 18, strokeColor = "#747474", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M10.6517 14V12.6667C10.6517 11.9594 10.3707 11.2811 9.87064 10.781C9.37055 10.281 8.69227 10 7.98503 10H3.98503C3.27778 10 2.5995 10.281 2.09941 10.781C1.59931 11.2811 1.31836 11.9594 1.31836 12.6667V14"
      stroke={strokeColor}
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6504 2.08545C11.2222 2.2337 11.7287 2.56763 12.0902 3.03482C12.4517 3.50202 12.6479 4.07604 12.6479 4.66678C12.6479 5.25752 12.4517 5.83154 12.0902 6.29874C11.7287 6.76594 11.2222 7.09987 10.6504 7.24812"
      stroke={strokeColor}
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6504 14.0002V12.6669C14.6499 12.0761 14.4533 11.5021 14.0913 11.0351C13.7293 10.5682 13.2225 10.2346 12.6504 10.0869"
      stroke={strokeColor}
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.98503 7.33333C7.45779 7.33333 8.65169 6.13943 8.65169 4.66667C8.65169 3.19391 7.45779 2 5.98503 2C4.51227 2 3.31836 3.19391 3.31836 4.66667C3.31836 6.13943 4.51227 7.33333 5.98503 7.33333Z"
      stroke={strokeColor}
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
